import { useEffect, useState } from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import { useWatch } from 'react-hook-form';

import ParentFieldArray from 'components/FormInputs/FieldArrays/ParentFieldArray';

import { RegistrationFormOutputValues } from '../utils/validationSchema';

export function ParentInformationStep() {
  const [parentRequired, setParentRequired] = useState(true);

  // Watch date_of_birth
  const dateOfBirth = useWatch<RegistrationFormOutputValues, 'date_of_birth'>({ name: 'date_of_birth' });

  // add a parent when the student is under 18
  useEffect(() => {
    if (!dateOfBirth) return;

    const birthDate = dayjs(dateOfBirth);
    const studentAge = dayjs().diff(birthDate, 'year');

    // If student is under 18, parents are required
    setParentRequired(studentAge < 18);
    console.log('Parent Required: ', studentAge < 18);
  }, [dateOfBirth]);

  return (
    <Stack gap={4}>
      {!parentRequired && (
        <Typography variant="h6" align="center">
          Parent information is optional when student is 18 years old or older.
        </Typography>
      )}
      <ParentFieldArray name="user_parents" numRequired={parentRequired ? 1 : 0} />
    </Stack>
  );
}
